export default __webpack_public_path__ + "static/Kundeninformation_DE-93890d4c66d8e484a83761c9c0e60299.pdf";